import * as Types from '@crimeos-frontend/crime-os/graphql'

import { gql } from '@apollo/client'
export type HandleSectionFragment = {
  __typename: 'HandleSection'
  sectionId: string
  name: string
  description: string
  sectionType: Types.HandleSectionTypeEnum
  defaultIconUrl: string
  selectedIconUrl: string
  supportedTemplateIds: Array<string>
}

export type HandleSectionTabFragment = {
  __typename: 'HandleSectionTab'
  handleSectionTabId: Types.HandleSectionTabEnum
  name: string
  totalCount: number
}

export type HandleFilterFieldConfigFragment = {
  __typename: 'HandleFilterFieldConfig'
  fieldId: string
  fieldDisplayName: string
  supportedOperators: Array<Types.HandleFilterOperator>
  supportedOptions: Array<string>
}

export type ImportHandlesResultFragment = {
  __typename: 'ImportHandlesResult'
  status: Types.ImportHandleStatus
  handlesImportedCount: number
  handleGroupIds: Array<string>
  recordIds: Array<string>
  reports: Array<{
    __typename: 'ImportEntityRowReport'
    id: string
    rowNo: number
    error?: string | null
  }>
}

export const HandleSectionFragmentDoc = gql`
  fragment HandleSection on HandleSection {
    sectionId
    name
    description
    sectionType
    defaultIconUrl
    selectedIconUrl
    supportedTemplateIds
  }
`
export const HandleSectionTabFragmentDoc = gql`
  fragment HandleSectionTab on HandleSectionTab {
    handleSectionTabId
    name
    totalCount
  }
`
export const HandleFilterFieldConfigFragmentDoc = gql`
  fragment HandleFilterFieldConfig on HandleFilterFieldConfig {
    fieldId
    fieldDisplayName
    supportedOperators
    supportedOptions
  }
`
export const ImportHandlesResultFragmentDoc = gql`
  fragment ImportHandlesResult on ImportHandlesResult {
    reports {
      id
      rowNo
      error
    }
    status
    handlesImportedCount
    handleGroupIds
    recordIds
  }
`
